import platformlogo1 from "@assets/images/WordPress-Logo.webp";
import platformlogo2 from "@assets/images/Shopify-Logo.webp";
import platformlogo3 from "@assets/images/Squarespace-Logo.webp";
import platformlogo4 from "@assets/images/Webflow-Logo.webp";
import platformlogo5 from "@assets/images/Showit-Logo.webp";
import platformlogo6 from "@assets/images/Drupal-Logo.webp";

 export const data =  [
    {
      img: platformlogo1,
      altText: 'WordPress Logo',
      mainHeading: 'WordPress',
      subHeading: ' The Ultimate All-Rounder',
      bulletPoints: [
        {
          boldText: 'Incredibly Versatile',
          lightText: ' Ideal for a vast range of projects, from personal blogs and e-commerce stores to major enterprise sites for companies like Sony Music.'
        },
        {
          boldText: 'Powerful & Customizable',
          lightText: 'Powers 43.4% of the web with a massive ecosystem of plugins, giving you more customizations and features than standard CMS.'
        },
        {
          boldText: 'Built for Content & SEO',
          lightText: 'SEO-oriented websites, the robust blogging engine and deep control over SEO elements are perfect for publishers and content marketers.'
        },
        {
          boldText: 'Modern Design Control',
          lightText: 'Features Full Site Editing, allowing us to design your entire site with greater creative freedom without needing to write code.'
        },
        {
          boldText: 'Open-Source & Consistently Evolving',
          lightText: 'Can function as a headless CMS to manage content on various interfaces. Being open-source ensures continuous innovation.'
        }
      ]
    },
    {
      img: platformlogo2,
      altText: 'Shopify Logo',
      mainHeading: 'Shopify',
      subHeading: 'The E-commerce Leader',
      bulletPoints: [
        {
          boldText: 'Multi-Channel Sales',
          lightText: 'Specifically designed for selling across multiple channels, including your online storefront, social media, and in-person with a unified Shopify POS system.'
        },
        {
          boldText: 'Scales with Your Business',
          lightText: ' Caters to businesses of all sizes, from new startups to high-volume merchants using the advanced features of Shopify Plus.'
        },
        {
          boldText: 'Simple & Reliable',
          lightText: 'Removes the technical burden from merchants with a user-friendly interface, and fully managed, PCI-compliant hosting.'
        },
        {
          boldText: 'Integrated Ecosystem',
          lightText: 'Features high-converting checkout with tools like Shop Pay and access to thousands of apps to extend your store’s functionality.'
        },
        {
          boldText: 'Built for Commerce',
          lightText: 'Offers robust features for B2B wholesale operations and helps you manage complex international sales with tools like Shopify Markets Pro.'
        },
         
      ]
    },
    {
      img: platformlogo3,
      altText: 'Squarespace Logo',
      mainHeading: 'Squarespace',
      subHeading: 'Elegant All-rounder',
      bulletPoints: [
        {
          boldText: 'Ideal for small businesses',
          lightText: 'Preferred by service-based small businesses to build visually appealing portfolios, schedule appointments and manage client bookings.'
        },
        {
          boldText: 'Design & Aesthetics',
          lightText: 'Offers a library of award-winning, polished, and responsive templates that are considered aesthetically superior to many competitors.'
        },
        {
          boldText: 'All-in-One Platform',
          lightText: 'Provides a complete package with hosting, domains, and marketing tools built-in, simplifying management for non-technical users.'
        },
        {
          boldText: 'Integration with Retail Operations',
          lightText: 'Offers integrations with widely used payment processing services and even POS systems.'
        },
        {
          boldText: 'Exclusive Content & Memberships',
          lightText: 'Allows creators and educators to easily sell access to exclusive content, courses, or newsletters.'
        },
      ]
    },
    {
      img: platformlogo4,
      altText: 'Webflow Logo',
      mainHeading: 'Webflow',
      subHeading: 'For Unparalleled Custom Design',
      bulletPoints: [
        {
          boldText: 'Design-Focused Brand Websites',
          lightText: 'A visual platform that builds aesthetically pleasing sites where custom animations and micro-interactions are key to the user experience.'
        },
        {
          boldText: 'No-code Animations',
          lightText: 'Features a powerful interactions engine, allowing us to create complex, custom animations without writing code.'
        },
        {
          boldText: 'Production-Ready Prototyping',
          lightText: 'Serves as the perfect bridge between design and development, enabling us to quickly prototype and launch production-ready websites.'
        },
        {
          boldText: 'Custom Code Integration',
          lightText: 'Allows for custom code integration, offering a high ceiling for adding advanced and unique functionality.'
        },
        {
          boldText: 'AI and Collaboration',
          lightText: '2025 updates introduced an AI Assistant for content generation and advanced collaboration tools for teams.'
        },
      ]
    },
    {
      img: platformlogo5,
      altText: 'Showit Logo',
      mainHeading: 'Showit',
      subHeading: 'For Visually-Driven Bloggers',
      bulletPoints: [
        {
          boldText: 'Design-Intensive Blogs',
          lightText: 'Offers complete creative freedom to build portfolio-focused blogs that capture the unique essence of your brand without conventional limitations.'
        },
        {
          boldText: 'Unrestricted Drag-and-Drop Design',
          lightText: 'Gives you true creative control ensuring your website design is unique and perfectly matches your vision.'
        },
        {
          boldText: 'Powerful Blogging with WordPress',
          lightText: 'Design your site with Showit’s flexible visual editor while managing your content with the world-class blogging and SEO tools of WordPress.'
        },
        {
          boldText: 'Simple & Effective E-commerce',
          lightText: 'Shopify Lite integration embeds simple e-commerce functionality, suitable for selling a small number of products or services.'
        },
        {
          boldText: 'Dedicated Mobile Experience',
          lightText: 'Beyond standard responsive design, Showit allows to fully customize the mobile version of your website separately from the desktop view.'
        },
        
      ]
    },
    {
      img: platformlogo6,
      altText: 'Drupal Logo',
      mainHeading: 'Drupal',
      subHeading: 'For Enterprise-Grade Security & Scale',
      bulletPoints: [
        {
          boldText: 'Enterprise & Government Standard',
          lightText: 'The trusted choice for large-scale projects, particularly in sectors like healthcare organizations and government agencies.'
        },
        {
          boldText: 'Complex Content Modeling',
          lightText: ' Excels at building sites with highly structured content, making it ideal for large databases, directories, and multi-faceted content hubs.'
        },
        {
          boldText: 'Granular Access Control',
          lightText: ' Features a sophisticated user role and permission system, allowing for detailed workflows and control.'
        },
        {
          boldText: 'Powerful Headless Architecture',
          lightText: 'Its API-first design allows it to serve as a centralized, secure content repository that can power various digital platforms.'
        },
        {
          boldText: 'Robust Security',
          lightText: ' Offers a security architecture and a dedicated security team, making it a trusted choice for mission-critical applications.'
        },
       
      ]
    },
  ]
